<template>
    <Details :item="item" :sourceType="sourceType" :loading="loading" :attachments="attachments"/>
</template>

<script setup>
import {
    itemsV3Client,
    itemBundlesClient,
    stocksClient,
} from "@/assets/apis/config";
import Details from "@/views/shop/Details.vue";
useHead({
  title: 'Product Details - Akhter Furnishers',
  meta: [
    { name: 'description', content: 'Get detailed information, specifications, and features about our quality furniture products.' }
  ]
})

const route = useRoute();

const itemDetail = ref(null);
const itemId = ref(route.query && route.query.id && route.query.id.length > 0 ? route.query.id : "");
const item = ref(null);
const sourceType = ref("item");
const loading = ref(false);
const attachments = ref([]);
const fetchStocks = async (id) => {
    // isLoading.value = true;
    let params = {
        textParams: [
            {
                'field': 'itemId',
                'value': id,
                'matchType': 'EXACT',
            }
        ],
        page: 1,
        size: 100
    }
    let pageToken = "";
    let stockList = [];

    do {
        let stockRes = await stocksClient.stockSearch(params)

        if (stockRes.status == 200 && !stockRes.networkError && stockRes?.body?.list?.length) {
            stockList = stockList.concat(stockRes.body.list);
            if (stockRes?.body?.nextPageToken?.length) {
                pageToken = stockRes.body.nextPageToken;
                params.page++
            }
        }

    } while (pageToken.length);

    // isLoading.value = false;
    return stockList;
};

const fetchData = async (id, type) => {
    loading.value = true;
    
    let res = null;
    if (type == 'bundle') {
        res = await itemBundlesClient.findOneJoin({ id: id, fetchSkus: true, fetchItems: true, fetchSkuDetails: true});
    } else if (type == 'item' || type == '') {
        res = await itemsV3Client.findOneJoin({ id: id, fetchSkus: true });
    }

    if (res.networkError) {
        /* TODO: show message */
        return;
    }

    if (res.status == 200 && res.body) {
        let itemBody = res.body;
        let categories = itemBody?.categories?.length ? itemBody.categories.map(i => i.category) : [];
        let collections = itemBody?.collections?.length ? itemBody.collections.map(i => i.collection) : [];
        
        if (type == 'item') {
            let stocks = await fetchStocks(id);
            item.value = {
                ...itemBody.item,
                stocks: stocks,
            }
        }
        if (type == 'bundle') {
            item.value = {
                ...itemBody.bundle,
                items: itemBody?.items,
                skuDetails: itemBody?.skuDetails,
            }
        }

        item.value.categories = categories;
        item.value.lookups = itemBody.lookups;
        item.value.keywords = itemBody.keywords;
        item.value.images = itemBody.attachments;
        item.value.skus = itemBody.skus;
        item.value.collections = collections;
    } else {
        return;
    }
    loading.value = false;
    if (process.client) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}

const fetchAttachments = async (id) => {
    let req = {
        page: 1,
        size: 10,
        textParams: [{
            field: 'itemId',
            value: id,
            matchType: 'EXACT',
        }]
    }
    let res = await itemsV3Client.findOneAttachment(req);

    if (res.networkError) {
        /* TODO: show message */
        return;
    }

    if (res.status == 200 && res?.body?.list) {
        let itemBody = res.body.list;
        let index = attachments.value.findIndex(i => i.itemId == id);
        if (index == -1) {
            attachments.value.push({
                itemId: id,
                images: itemBody
            });
        }
    } else {
        return;
    }
}

watch(
    ()=>route.query.id,
    () => {
        console.log("~~~~~~~~route");
        console.log(route);
        if ( route.query && route.query.id && route.query.id.length > 0) {
            itemId.value = route.query.id;
            if (route?.query?.sourceType) {
                sourceType.value = route.query.sourceType;
                // type = route.query.sourceType
            }
            fetchData(route.query.id, sourceType.value);
        }
    },
    { immediate: true, deep: true }
);

watch(item, () => {
    if (item.value != null) {
        
        itemDetail.value = item.value;
        if (sourceType.value == 'bundle' && item.value?.items?.length) {
            item.value.items.forEach(item => {
                fetchAttachments(item.id)
            });
        }
        // ✅ Inject dynamic title, meta description, and schema
        useHead({
            title: `${item.value.name} - Akhter Furnishers`,
            meta: [
                {
                    name: 'description',
                    content: item.value.description || 'Get detailed information, specifications, and features about our quality furniture products.'
                }
            ],
            script: [
                {
                    type: 'application/ld+json',
                    children: JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Product",
                        name: item.value.name,
                        image: item.value.images?.[0]?.url || "",
                        description: item.value.description || "",
                        sku: item.value.sku,
                        brand: {
                            "@type": "Brand",
                            name: item.value.brand || "Akhter"
                        },
                        offers: {
                            "@type": "Offer",
                            url: `https://akhter.com.bd/product/${item.value.slug}`,  // 🔗 your site + slug
                            priceCurrency: item.value.currency || "BDT",              // 📦 fallback currency
                            price: item.value.price || "0",
                            availability: `https://schema.org/${item.value.availability || "InStock"}`,  // 🔄 dynamic availability
                            itemCondition: "https://schema.org/NewCondition"         // 🆕 fixed condition
                        }
                    })
                }
            ]
        });
    }
}, { immediate: true, deep: true });



</script>

<style lang="scss">
.tab-active {
    color: #F69320;
    transition: 0.3s;
    text-align: center;
    padding: 10px 0px;
    cursor: pointer;
    width: 100%;
    border-bottom: 2px solid #F69320;
}

.bottom-btn {
    text-align: center;
    font-size: 16px;
    padding: 10px 0px;
    height: 50px;
    cursor: pointer;
}

.bottom-btn:hover {
    color: #F69320;
    transition: 0.3s;
    text-align: center;
    padding: 10px 0px;
}
</style>
